// Single source of truth for Sell Order / Batch Sell Order payment types.
// `value` is the code persisted on sell_order_payments.payment_type in bps-go;
// `label` is the display text. Used by the payment entry dropdowns
// (sell-order / batch-order PaymentRow) and the Payment Type table filter.
export const getPaymentTypeOptions = (t) => [
  { value: 'visa', label: t('Visa') },
  { value: 'mastercard', label: t('Mastercard') },
  { value: 'amex', label: t('American Express') },
  { value: 'debit_card', label: t('Debit Card') },
  { value: 'discount', label: t('Discount') },
  { value: 'promotional', label: t('Promotional') },
  { value: 'berkeley_expired_card', label: t('Berkeley Expired Card') },
  { value: 'cibc_expired_card', label: t('CIBC Expired Card') },
  { value: 'online', label: t('Online') },
  { value: 'pay_by_mall', label: t('Pay-by-Mall') },
  { value: 'guest_resolution', label: t('Guest Resolution') },
  { value: 'wechat', label: t('WeChat') },
  { value: 'alipay', label: t('AliPay') },
  { value: 'union_pay', label: t('Union Pay') },
  { value: 'other', label: t('Other') },
  { value: 'discover', label: t('Discover') },
  { value: 'code', label: t('Code') },
  { value: 'eft', label: t('EFT') },
];
